import { useEffect, useState } from "react";

import { Offer } from "../utils/API";
import {
  brandTypeFromRoute,
  getPartnerBoostBrands,
} from "../utils/partnerBoost";

export const useBrandOffers = (category: string) => {
  const [offers, setOffers] = useState<Offer[]>([]);

  useEffect(() => {
    const fetchBrandOffers = async () => {
      const brandType = brandTypeFromRoute(category);
      if (!brandType) {
        setOffers([]);
        return;
      }

      const { result, brands } = await getPartnerBoostBrands(brandType);
      if (!result) {
        setOffers([]);
        return;
      }

      setOffers(brands);
    };

    fetchBrandOffers();
  }, [category]);

  return offers;
};
